exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".attendee-details label {\n\twidth:50%;\n\tfloat:left;\n}\n.f-bold {\n\tfont-weight:bold;\n}\n.attendee-details label span {\n\tpadding:0 5px;\n}\n.attendee-top-field input[type=\"email\"] {\n\twidth: calc(100% - 90px);\n\tdisplay: inline-block;\n}\n\n.customAccordion .innerData {\n    display: block !important;\n}\n.attendee-list-bg .innerData {\n\tborder-top: 0 !important;\n\tpadding: 0 15px;\n}\n.border-top {\n\tborder-top: 1px solid rgba(0,0,0,.125);\n\tpadding: 10px 0;\n}\n.border-top label {\n\tmargin: 0;\n}\n\n.attendee-count-list {\n    width: 100%;\n\t/* max-height: 350px; */\n\theight: calc(100vh - 266px);\n    overflow: auto;\n\tpadding-right: 15px;\n}\n\n\n\n.attendee-count-list::-webkit-scrollbar-track {\n\t-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);\n\tborder-radius: 10px;\n\tbackground-color: #F5F5F5;\n}\n\n.attendee-count-list::-webkit-scrollbar {\n\twidth: 5px;\n\tbackground-color: #333;\n}\n\n.attendee-count-list::-webkit-scrollbar-thumb {\n\tborder-radius: 10px;\n\t-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);\n\tbackground-color: #333;\n}\n\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/event/attendees/attendees.component.css
// module id = ../../../../../src/app/event/attendees/attendees.component.css
// module chunks = main